// THIS IS AN AUTO GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export const VERSION = '7.7.1';
export const VERSION_NUMBER = 707001000;
